export enum ELockOCMessageTypes {
  NENHUM,
  REPROVADO_GR,
  SEM_CADENCIA,
  AGUARDANDO_VALIDACAO,
  WAIT_FOR_NOTIFICATION,
}
